import { render, staticRenderFns } from "./NotBeingWorkedOn.vue?vue&type=template&id=b14a0356&scoped=true"
import script from "./NotBeingWorkedOn.vue?vue&type=script&lang=js"
export * from "./NotBeingWorkedOn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b14a0356",
  null
  
)

export default component.exports